// import Util from './common-tools'
;(function () {
  // 隐藏更多
  // Util.callNew('mtp.hideNaviMoreBtn', {
  //   isHide: true,
  //   success: function (res) {
  //     console.log('隐藏右上角更多按钮', res)
  //   }
  // })
  /**
   * 适配老项目样式尺寸
   */
  function setRemUnit () {
    var docEl = document.documentElement
    const rate = 19/3
    var rem = docEl.clientWidth / rate
    docEl.style.fontSize = rem + 'px'
  }

  setRemUnit()
  // window.addEventListener('pageshow', function (e) {
  //   if (e.persisted) {
  //     setRemUnit()
  //   }
  // })
})()
